// --------------------------------------------------------------------------
// backgroundImage.js
// --------------------------------------------------------------------------
// Although we're using object-fit and <picture> polyfills, it's not 100% reliable.
// This module define a custom fallback to background image.
// --------------------------------------------------------------------------

EC.backgroundImage = function () {

    'use strict';

    function init () {
        // If the browser does support object-fit, we don't need to continue
        if ("objectFit" in document.documentElement.style !== false) {
            return;
        }
        else{
            $('.js-background-image').each(setBackgroundImage);
        }
    }

    function setBackgroundImage () {
        const $backgroundWrap = $(this);
        $backgroundWrap.children().remove();
        $backgroundWrap.css({
            "background" : 'url(' + $backgroundWrap.data('background') + ') no-repeat center center',
            "background-size": 'cover'
        });
    }

    return {
        init: init
    };

}();